/**********************************************************/
// サムネイルAPIのresponse内容をチェック
/**********************************************************/
// 引数
// thumbnailInfo : APIの実行結果(response)
/**********************************************************/
function componentApiCheckThumbnail(thumbnailInfo) {
    if (thumbnailInfo.length == 24) {
        for (var i = 0; i < thumbnailInfo.length; i++) {
            if (thumbnailInfo[i].hour != undefined && thumbnailInfo[i].sequence != undefined) {
                for (var j = 1; j <= thumbnailInfo[i].sequence; j++) {
                    if (thumbnailInfo[i][j] != undefined) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        }
    } else {
        return false;
    }
}

export default componentApiCheckThumbnail